export default __webpack_public_path__ + "static/media/3.debbdd02.jpg";